// src/components/inputs/StringInput.js
import { Input } from "@material-tailwind/react";
import PropTypes from "prop-types";
import React from "react";

const StringInput = ({ label, value, onChange }) => {
  // Generate a safe ID by replacing spaces with hyphens and converting to lowercase
  const safeId = `string-input-${label.replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <div className="mb-6">
      <Input
        id={safeId}
        label={label}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

StringInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default StringInput;
